import React, { useEffect, useState, useMemo } from 'react';
import './report.css';
import { useCSVDownloader } from 'react-papaparse';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from 'react-router-dom';
import { exportToCSV, exportToExcel, exportToPDF } from '../../utils/Exports';
import { FormGroup, Button, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import $ from 'jquery';
import moment from 'moment';
import formatHeaderName from '../../utils/formatHeaderName';
import { parseValue } from '../../utils/Common';
import Table from '../common/Table';

const common = require('../../utils/Common');

export default function ServiceReports() {
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const { CSVDownloader } = useCSVDownloader();
  const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
  
  const navigate = useNavigate();

  useEffect(() => {
    checkAccess();
  }, []);

  const checkAccess = async () => {
    let rights = await common.checkAccessRights(window.location.pathname);
    if (!rights.view) {
      alert("Access Denied");
      navigate("/");
      return;
    } else {
      setUserRights(rights);
      getReportData();
    }
}
  const getReportData = async (limit = 10, offset = 0, search = {}, isExport = 0) => {
    var parameters = {
      'source':'Admin',
      'report_name': 'service_reports',
      'start_date': $('#Date-from').val(),
      'end_date': $('#Date-to').val(),
    }
    if (!isExport) {
      parameters.limit = limit;
      parameters.offset = offset;
    }
    let response = await common.apiRequest('post', '/reports/get-reports', parameters);
    let data = (response.data && response.data.data) ? response.data.data : [];
    if (isExport) {
      return data.reportData;
    }
    const keysToExclude = ['order_item_id'];
    const cols = common.getReportColumns(keysToExclude, data.keys, ChangeIntDecimals);
    
    setColumnDefs(cols);

    // Set row data
    setRowData(data.reportData);
    setTotalRecords(data.totalRecords);
  }
  
  const data = rowData.map((row, index) => {
    const newRow = {
        slNo: index + 1 
    };
    Object.keys(row).forEach(key => {
      newRow[formatHeaderName(key)] = row[key];
    });
    return newRow;
  });
  const ChangeIntDecimals = [
    'invoice_amount','taxable_amount','igst','cgst','sgst','utgst','cess','total_amount_recive'
  ];

  const handleExportCSV = async () => {
    let data = await getReportData(0, 0, {}, 1);
    exportToCSV(data, 'Service report');
}

const handleExportExcel = async () => {
  let data = await getReportData(0, 0, {}, 1);
    exportToExcel(data, 'Service report');
}

const handleExportPDF = async () => {
  let data = await getReportData(0, 0, {}, 1);
    exportToPDF(data, 'Service report');
}
  return (
    <>
      <div className="row report-margin">
        <div className='col-md-10'>
        <h3>service Reports</h3>
        </div>
        <Form className='row'>
                        <FormGroup className='col-md-4 row'>
                            <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                            <input type='date' defaultValue={moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getReportData()} className="form-control col-md-5" id="Date-from" name="Date-from"></input>
                        </FormGroup>
                        <FormGroup className='col-md-4 row'>
                            <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
                            <input type='date' defaultValue={moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getReportData()} className="form-control col-md-5" id="Date-to" name="Date-to"></input>
                        </FormGroup>
                    </Form>
        <div className="col-md-12 button-container">
        <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
         <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
         <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>

        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <div className="ag-theme-quartz" style={{height: 600, width: '100%'}}>
            <Table 
              columns={columnDefs}
              data={rowData}
              totalRecords={totalRecords}
              pageSize={10}
              onPageChange = {getReportData}
            />
          </div>
        </div>
      </div>
    </>
  )
}